import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  IconButton,
  Box,
  useMediaQuery,
  useTheme,
  Fade,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

export default function EventStatusDialog({
  open,
  title,
  message,
  actionLabel = 'Go to Tokens',
  onClose,
}) {
  const theme = useTheme();
  const isXs = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xs"
      TransitionComponent={Fade}
      TransitionProps={{ timeout: 200 }}
      fullWidth
      // fullScreen={isXs} // full screen on phones
      PaperProps={{
        sx: {
          // On phones: edge-to-edge full screen; on larger screens: centered card
          borderRadius: { xs: 0, sm: 3 },
          p: { xs: 0, sm: 1 },
          boxShadow: { xs: 'none', sm: 8 },
        },
      }}>
      <DialogTitle
        sx={{
          position: 'sticky',
          top: 0,
          bgcolor: 'background.paper',
          zIndex: 1,
          fontWeight: 700,
          fontSize: { xs: '2rem', sm: '1.25rem' },
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          px: { xs: 2, sm: 2 },
          py: { xs: 1.25, sm: 1.5 },
          borderBottom: (t) => `1px solid ${t.palette.divider}`,
        }}>
        {title}
        <IconButton
          aria-label="close"
          onClick={onClose}
          size={isXs ? 'medium' : 'small'}
          edge="end"
          sx={{
            ml: 1,
            color: 'grey.600',
            '&:hover': { color: 'grey.800', transform: 'scale(1.05)' },
            transition: 'all 0.2s ease',
            // Larger touch target on mobile
            p: { xs: 1, sm: 0.5 },
          }}>
          <CloseIcon fontSize={isXs ? 'large' : 'small'} />
        </IconButton>
      </DialogTitle>
      <DialogContent
        sx={{
          px: { xs: 3, sm: 3 },
          py: { xs: 2, sm: 2 },
        }}
      >
        <Box sx={{ py: { xs: 1, sm: 1 } }}>
          <Typography
            variant={isXs ? "h4" : "h6"}
            color="text.primary"
            sx={{
              lineHeight: 1.6,
              fontWeight: { xs: 600, sm: 600 },
              // fontSize: { xs: "2rem", sm: "1.1rem" },
            }}
          >
            {message}
          </Typography>
        </Box>
      </DialogContent>

      <DialogActions
        sx={{
          px: { xs: 2, sm: 2 },
          pt: { xs: 1, sm: 1 },
          pb: { xs: 2, sm: 2 },
          // On full-screen mobile, keep actions docked with slight safe-area padding
          borderTop: (t) => ({ xs: `1px solid ${t.palette.divider}`, sm: "none" }),
        }}
      >
        <Button
          onClick={onClose}
          variant="contained"
          // fullWidth
          sx={{
            textTransform: "none",
            borderRadius: { xs: 2, sm: 2 },
            fontWeight: 600,
            py: { xs: 1.1, sm: 1.2 },
            fontSize: { xs: "1.2rem", sm: "1rem" },
            // If you want gradient later, uncomment:
            // background: "linear-gradient(135deg, #1976d2 0%, #1565c0 100%)",
            // "&:hover": {
            //   background: "linear-gradient(135deg, #1565c0 0%, #0d47a1 100%)",
            // },
          }}
        >
          {actionLabel}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
